import React from 'react';
import {TouchableOpacity, View} from 'react-native';

import InfoPopover from '/component/partial/InfoPopover';
import {PopoverContext} from '/provider/PopoverProvider/createPopoverProvider';

import {styles} from '../ChatModal.style';

interface ChatInfoSheetProps {
  visible: boolean;
  onClose: () => void;
  heading: string;
  body: string;
  contentInsetStyle: any;
}

const ChatInfoSheet: React.FC<ChatInfoSheetProps> = ({
  visible,
  onClose,
  heading,
  body,
  contentInsetStyle,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <View style={styles.infoPopoverContainer}>
      <TouchableOpacity
        style={styles.infoPopoverBackdrop}
        onPress={onClose}
        accessible={false}
      />
      <View style={styles.infoPopoverSheet}>
        <View style={contentInsetStyle}>
          <PopoverContext.Provider
            value={{
              popoverShow: () => {},
              popoverHide: onClose,
            }}>
            <InfoPopover heading={heading} body={body} />
          </PopoverContext.Provider>
        </View>
      </View>
    </View>
  );
};

export default ChatInfoSheet;
